module.exports = __webpack_public_path__ + "img/Span-02.074c11d1.jpg";